// ═══════════════════════════════════════
// SHARE — Modale de partage de partition
// ═══════════════════════════════════════

import { currentId, currentSlug, currentUser } from './state.js';
import { authHeaders } from './common/auth.js';
import { openModal, closeModal } from './modal.js';
import { t } from './i18n.js';

// ═══════════════════════════════════════
// OUVERTURE
// ═══════════════════════════════════════

export function openShareModal() {
    openModal('share', _mountShare);
}

async function _mountShare(nav, controller) {
    const { signal } = controller;

    console.log('mountShare', signal);

    document.querySelector('#modal-content .btn-cancel')
        ?.addEventListener('click', () => closeModal(), { signal });

    document.getElementById('share-send')
        ?.addEventListener('click', () => submitShare(), { signal });

    document.querySelectorAll('.share-channel-btn').forEach(btn => {
        btn.addEventListener('click', () => _handleChannel(btn.dataset.channel), { signal });
    });

    await _loadGroups(signal);
}

// ═══════════════════════════════════════
// CHARGEMENT DES GROUPES
// ═══════════════════════════════════════

async function _loadGroups(signal) {
    if (!currentUser) return;

    try {
        const res    = await fetch('/api/users.php?action=groups', { headers: authHeaders(), signal });
        const groups = await res.json();
        if (!Array.isArray(groups) || !groups.length) return;

        const section = document.getElementById('share-groups-section');
        const list    = document.getElementById('share-group-list');
        if (!section || !list) return;

        list.innerHTML = groups.map(g => `
            <label class="share-group-item">
                <input type="checkbox" value="${g.id}">
                <span class="share-group-name">${escHtml(g.name)}</span>
                ${g.description ? `<span class="share-group-desc">${escHtml(g.description)}</span>` : ''}
            </label>
        `).join('');

        section.style.display = '';
    } catch (e) {
        if (e.name !== 'AbortError') {
            // Silencieux : la section reste cachée
        }
    }
}

// ═══════════════════════════════════════
// CANAUX RAPIDES (WhatsApp, Telegram, Facebook, Copier)
// ═══════════════════════════════════════

function _handleChannel(channel) {
    const slug  = currentSlug;
    const title = document.getElementById('partition-title-display')?.textContent?.trim() || '';
    const link  = `${window.location.origin}/partitions/${slug}`;

    if (channel === 'copy') {
        navigator.clipboard.writeText(link).then(() => {
            const btn = document.querySelector('[data-channel="copy"]');
            if (btn) {
                btn.classList.add('copied');
                setTimeout(() => btn.classList.remove('copied'), 2000);
            }
        });
        return;
    }

    const urls = {
        whatsapp: `https://wa.me/?text=${encodeURIComponent(title + ' — ' + link)}`,
        telegram: `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(title)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
    };

    if (urls[channel]) window.open(urls[channel], '_blank');
}

// ═══════════════════════════════════════
// ENVOI EMAIL + GROUPES
// ═══════════════════════════════════════

export async function submitShare() {
    const errEl  = document.getElementById('share-error');
    const status = document.getElementById('share-send-status');
    if (errEl)  errEl.textContent    = '';
    if (status) status.style.display = 'none';

    if (!currentUser) {
        if (errEl) errEl.textContent = t('share.error_login');
        return;
    }

    const rawEmails = document.getElementById('share-email-input')?.value ?? '';
    const emails    = rawEmails.split(/[\n,;]/).map(e => e.trim()).filter(Boolean);
    const groupIds  = [...document.querySelectorAll('#share-group-list input[type="checkbox"]:checked')]
                        .map(cb => parseInt(cb.value));

    if (!emails.length && !groupIds.length) {
        if (errEl) errEl.textContent = t('share.error_no_recipient');
        return;
    }

    const btn = document.getElementById('share-send');
    if (btn) btn.disabled = true;
    _showStatus(t('share.status_generating'), false);

    try {
        _showStatus(t('share.status_sending'), false);

        const res = await fetch('/api/share.php', {
            method: 'POST',
            headers: authHeaders(),
            body: JSON.stringify({
                partition_id: currentId,
                channels:     ['email'],
                group_ids:    groupIds,
                emails,
            }),
        });
        const data = await res.json();

        if (data.sent?.length) {
            _showStatus(t('share.status_sent', { recipients: data.sent.join(', ') }), false);
        } else if (data.skipped?.length) {
            _showStatus(t('share.status_failed', { recipients: data.skipped.join(', ') }), true);
        } else {
            _showStatus(data.error || t('share.error_no_valid'), true);
        }
    } catch (e) {
        if (errEl) errEl.textContent = t('share.error_network');
    } finally {
        if (btn) btn.disabled = false;
    }
}

function _showStatus(msg, isError) {
    const el = document.getElementById('share-send-status');
    if (!el) return;
    el.textContent   = msg;
    el.className     = 'share-send-status' + (isError ? ' error' : '');
    el.style.display = '';
}

// ═══════════════════════════════════════
// UTILITAIRE
// ═══════════════════════════════════════

function escHtml(str) {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}